import { render, staticRenderFns } from "./AddDiscipline.vue?vue&type=template&id=c504dfb6&scoped=true"
import script from "./AddDiscipline.vue?vue&type=script&lang=js"
export * from "./AddDiscipline.vue?vue&type=script&lang=js"
import style0 from "./AddDiscipline.vue?vue&type=style&index=0&id=c504dfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c504dfb6",
  null
  
)

export default component.exports